import { ResultsState } from '@immosky/types';
import { createFeatureSelector } from '@ngrx/store';

export const selectResultsState =
  createFeatureSelector<ResultsState>('results');
